module.exports = {"audiences":["allMembers"],"experimentVersion":"v1","experimentAllocation":0,"defaultWeight":1,"defaults":{"enabled":false},"autoTrack":true,"variations":[{"name":"V1","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/teamMembersTabLayout.json
// module id = 5FtJ
// module chunks = 0